import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';

import type { ComponentOrMapping, ComponentPage } from '@cfg/pageRoutes.tsx';
import { RequireStaff } from '@features/cms/components/RequireStaff.tsx';
import { useAppSelector } from '@store/store.tsx';
import { selectSiteApps } from '@store/slices/settingsSlice.tsx';

const StaffListPage = lazyWithRetry(() => import('@erp/staff/pages/StaffListPage.tsx'));
const RrhhAgreementsPage = lazyWithRetry(() => import('../pages/RrhhAgreementsPage.tsx'));
const RrhhSettlementsPage = lazyWithRetry(() => import('../pages/RrhhSettlementsPage.tsx'));

const RrhhStaffNode = () => {
  const siteApps = useAppSelector(selectSiteApps) ?? [];
  const rrhhAgreementsEnabled = siteApps.includes('erp__rrhh');

  return (
    <RequireStaff
      requiredApps={['erp', 'erp__staff']}
      render={() => <StaffListPage rrhhAgreementsEnabled={rrhhAgreementsEnabled} />}
    />
  );
};

const RrhhAgreementsNode = () => (
  <RequireStaff requiredApps={['erp', 'erp__rrhh']} render={() => <RrhhAgreementsPage />} />
);

const RrhhSettlementsNode = () => (
  <RequireStaff requiredApps={['erp', 'erp__rrhh']} render={() => <RrhhSettlementsPage />} />
);

const staffNode = {
  component: RrhhStaffNode,
} satisfies ComponentPage;

const agreementsNode = {
  component: RrhhAgreementsNode,
} satisfies ComponentPage;

const settlementsNode = {
  component: RrhhSettlementsNode,
} satisfies ComponentPage;

const rrhhRoutes: ComponentOrMapping = {
  erp: {
    rrhh: {
      staff: staffNode,
      agreements: agreementsNode,
      settlements: settlementsNode,
    },
  },
};

export default rrhhRoutes;
